export const Actions = {
  SENDERLOGIN: "SENDERLOGIN",
  USERLOGIN: "USERLOGIN",
  USERLOGOUT: "USERLOGOUT",
  SENDERLOGOUT: "SENDERLOGOUT",
  TRAVELERLOGIN: "TRAVELERLOGIN",
  TRAVELERLOGOUT: "TRAVELERLOGOUT",
  SENDERREGISTER: "SENDERREGISTER",
  TRAVELERREGISTER: "TRAVELERREGISTER",
  UPDATE_AUTH_STATE: "UPDATE_AUTH_STATE",
  SET_SENDER_TRAVELER_INFO : "SET_SENDER_TRAVELER_INFO",
  SET_SEARCH_FILTER  : "SET_SEARCH_FILTER",
  CONTACT_DATA  : "CONTACT_DATA",
  FETCH_HOME_PAGE_DATA_SUCCESS  : "FETCH_HOME_PAGE_DATA_SUCCESS",
  FETCH_SENDER_PAGE_DATA_SUCCESS  : "FETCH_SENDER_PAGE_DATA_SUCCESS",
  FETCH_TRAVELER_PAGE_DATA_SUCCESS  : "FETCH_TRAVELER_PAGE_DATA_SUCCESS",
  FETCH_ABOUT_PAGE_DATA_SUCCESS  : "FETCH_ABOUT_PAGE_DATA_SUCCESS",
  FETCH_HOWITWORK_PAGE_DATA_SUCCESS  : "FETCH_HOWITWORK_PAGE_DATA_SUCCESS",
  FETCH_CITIES  : "FETCH_CITIES",
   
};
export default {};
